(function () {
  function addStyle() {
    if (document.getElementById('fh-gift-light-polish')) return;
    var style = document.createElement('style');
    style.id = 'fh-gift-light-polish';
    style.textContent = [
      '.fh-story{display:none!important}',
      '.fh-newsletter{display:none!important}',
      '.fh-bundle{padding-top:72px!important;padding-bottom:78px!important}',
      '.fh-bundle__intro{max-width:980px!important;margin-bottom:28px!important}',
      '.fh-bundle__intro .fh-kicker{color:#a77c29!important}',
      '.fh-bundle__intro h2{font-size:clamp(48px,5.2vw,88px)!important;line-height:.9!important;margin-bottom:16px!important}',
      '.fh-bundle__intro p{font-size:17px!important;line-height:1.55!important;color:#27221a!important;max-width:900px!important}',
      '.fh-bundle-search{background:#080808!important;padding:22px!important;margin-bottom:28px!important;border:1px solid rgba(201,156,63,.28)!important}',
      '.fh-bundle-search label{color:#c99c3f!important;margin-bottom:12px!important}',
      '.fh-bundle-search input{background:#fff!important;border:1px solid #c99c3f!important;border-radius:999px!important;padding:17px 22px!important;color:#111!important}',
      '#gift-set .fh-bundle-search [role="listbox"],#gift-set .fh-bundle-search .predictive-search,#gift-set .fh-bundle-search .search-results,#gift-set .fh-bundle-search .fh-country-results,#gift-set .fh-bundle-search .fh-country-suggestions,#gift-set .fh-bundle-search .fh-search-suggestions{display:none!important}',
      '.fh-bundle__grid{gap:28px!important;grid-template-columns:minmax(0,1fr) 340px!important}',
      '.fh-bundle-products:before{content:"Suggested gift picks";grid-column:1/-1;color:#a77c29;font-size:12px;font-weight:900;letter-spacing:.22em;text-transform:uppercase;margin:0 0 -4px}',
      '.fh-bundle-products{gap:18px!important}',
      '.fh-bundle-card{background:#fffdf8!important;border:1px solid rgba(11,11,11,.08)!important;box-shadow:0 8px 22px rgba(23,18,10,.04)!important;transition:transform .16s ease,border-color .16s ease,box-shadow .16s ease!important}',
      '.fh-bundle-card:hover{transform:translateY(-2px)!important;border-color:rgba(201,156,63,.55)!important;box-shadow:0 16px 34px rgba(23,18,10,.08)!important}',
      '.fh-bundle-card.is-selected{border-color:#c99c3f!important;box-shadow:0 0 0 2px rgba(201,156,63,.18)!important}',
      '.fh-bundle-card img{background:#fff!important;border:1px solid rgba(11,11,11,.05)!important;border-radius:0!important;padding:8px!important}',
      '.fh-bundle-card button{min-width:82px!important;background:#c99c3f!important;color:#0b0b0b!important;border:0!important;font-weight:900!important}',
      '.fh-bundle-card.is-selected button{background:#0b0b0b!important;color:#fff!important}',
      '.fh-gift-summary{top:96px!important;padding:30px!important;background:#080808!important;box-shadow:0 18px 42px rgba(23,18,10,.18)!important}',
      '.fh-gift-summary h3{color:#c99c3f!important;margin-top:0!important}',
      '.fh-gift-count{font-size:34px!important;line-height:1.05!important}',
      '.fh-gift-list{color:#f3efe7!important}',
      '.fh-gift-total{font-size:17px!important}',
      '.fh-gift-summary .fh-btn{width:100%!important;background:#c99c3f!important;border-color:#c99c3f!important;color:#0b0b0b!important}',
      '.fh-gift-summary p{font-size:13px!important;line-height:1.5!important;color:#cfc7b8!important}',
      '.fh-gift-search-status{margin-top:10px;color:#fff;background:rgba(201,156,63,.16);border:1px solid rgba(201,156,63,.4);padding:10px 12px;font-size:13px;line-height:1.35}',
      '.fh-gift-search-results{display:grid;gap:10px;margin-top:14px}',
      '.fh-gift-search-result{display:grid;grid-template-columns:70px 1fr auto;align-items:center;gap:14px;background:#fffdf8;color:#0b0b0b;border:1px solid rgba(201,156,63,.4);padding:12px;text-decoration:none}',
      '.fh-gift-search-result img{width:64px;height:50px;object-fit:contain;background:#fff;border:1px solid rgba(11,11,11,.06);padding:5px}',
      '.fh-gift-search-result span{display:block}',
      '.fh-gift-search-country{font-size:11px;font-weight:900;letter-spacing:.16em;text-transform:uppercase;color:#a77c29}',
      '.fh-gift-search-name{font-size:15px;font-weight:900;line-height:1.2;margin-top:3px}',
      '.fh-gift-search-add{border:0;background:#c99c3f;color:#0b0b0b;padding:12px 16px;font-weight:900;cursor:pointer;white-space:nowrap}',
      '.fh-gift-search-result.is-selected .fh-gift-search-add{background:#0b0b0b;color:#fff}',
      '.fh-lead-popup{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:22px;background:rgba(0,0,0,.58);opacity:0;visibility:hidden;pointer-events:none;transition:opacity .22s ease,visibility .22s ease}',
      '.fh-lead-popup.is-open{opacity:1;visibility:visible;pointer-events:auto}',
      '.fh-lead-popup__card{position:relative;width:min(1040px,100%);display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.15fr);align-items:stretch;background:#f7f2e8;color:#0b0b0b;border:0;outline:0;box-shadow:0 30px 80px rgba(0,0,0,.35)}',
      '.fh-lead-popup__media{width:100%;aspect-ratio:1/1;background:#080808;min-height:0;overflow:hidden;border:0;outline:0}',
      '.fh-lead-popup__media img{width:100%;height:100%;object-fit:cover;object-position:50% 43%;display:block}',
      '.fh-lead-popup__content{padding:42px}',
      '.fh-lead-popup__kicker{margin:0 0 14px;color:#a77c29;text-transform:uppercase;letter-spacing:.22em;font-size:12px;font-weight:900}',
      '.fh-lead-popup h2{margin:0 0 16px;font-size:clamp(34px,4vw,58px);line-height:.94;font-weight:900;letter-spacing:-.02em}',
      '.fh-lead-popup p{margin:0 0 22px;font-size:16px;line-height:1.55;color:#2b261f}',
      '.fh-lead-popup form{display:grid;grid-template-columns:1fr auto;gap:10px;margin:0 0 16px}',
      '.fh-lead-popup input[type=email]{min-height:52px;border:1px solid rgba(11,11,11,.22);background:#fff;padding:0 16px;font-size:15px;color:#111}',
      '.fh-lead-popup button[type=submit]{border:0;background:#c99c3f;color:#0b0b0b;padding:0 18px;font-weight:900;cursor:pointer}',
      '.fh-lead-popup__close{position:absolute;right:14px;top:14px;width:38px;height:38px;border:0;border-radius:999px;background:#fff;color:#111;font-size:24px;line-height:1;cursor:pointer;z-index:2}',
      '.fh-lead-popup__links{display:flex;gap:16px;flex-wrap:wrap;align-items:center}',
      '.fh-lead-popup__links a{font-weight:900;color:#0b0b0b;text-decoration:underline;text-decoration-color:#c99c3f;text-underline-offset:5px}',
      '.fh-lead-popup__code{display:inline-flex;align-items:center;min-height:34px;padding:0 10px;background:#0b0b0b;color:#fff;font-size:12px;font-weight:900;letter-spacing:.12em}',
      '@media(max-width:767px){.fh-lead-popup{align-items:flex-end;padding:12px}.fh-lead-popup__card{grid-template-columns:1fr;max-height:92vh;overflow:auto;border:0;outline:0}.fh-lead-popup__media{width:100%;height:auto;min-height:0;aspect-ratio:1/1;border:0;outline:0}.fh-lead-popup__content{padding:24px 20px 22px}.fh-lead-popup form{grid-template-columns:1fr}.fh-lead-popup button[type=submit]{min-height:50px}.fh-lead-popup h2{font-size:34px}}',
      '@media(max-width:990px){.fh-bundle{padding-top:54px!important;padding-bottom:60px!important}.fh-bundle__grid{grid-template-columns:1fr!important}.fh-gift-summary{position:static!important;order:-1}.fh-bundle-card{grid-template-columns:86px 1fr auto!important}.fh-bundle-card img{width:78px!important;height:62px!important}.fh-bundle-search{padding:18px!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function removeProcessSection() {
    var story = document.querySelector('[data-fahari-home] > .fh-story');
    if (story) story.remove();
  }

  function improveCopy() {
    var bundle = document.querySelector('#gift-set');
    if (!bundle || bundle.dataset.fhLightGift === 'true') return;
    bundle.dataset.fhLightGift = 'true';

    var kicker = bundle.querySelector('.fh-bundle__intro .fh-kicker');
    var heading = bundle.querySelector('.fh-bundle__intro h2');
    var body = bundle.querySelector('.fh-bundle__intro p:not(.fh-kicker)');
    var label = bundle.querySelector('.fh-bundle-search label');
    var input = bundle.querySelector('#fh-bundle-country');
    var summaryHeading = bundle.querySelector('.fh-gift-summary h3');
    var checkout = bundle.querySelector('[data-gift-checkout]');

    if (kicker) kicker.textContent = 'Gift more meaning';
    if (heading) heading.textContent = 'Build a bracelet gift set.';
    if (body) body.textContent = 'Pick bracelets for family, friends, or yourself. Mix countries, add as many as you want, and checkout with 10% savings applied.';
    if (label) label.textContent = 'Find a country for your gift';
    if (input) input.placeholder = 'Search your country';
    if (summaryHeading) summaryHeading.textContent = 'Your gift set';
    if (checkout) checkout.textContent = 'Checkout gift set';
  }

  function giftSearchAddsToSet() {
    var bundle = document.querySelector('#gift-set');
    if (!bundle || bundle.dataset.fhGiftSearchAdd === 'true') return;
    bundle.dataset.fhGiftSearchAdd = 'true';

    var form = bundle.querySelector('.fh-bundle-search form');
    var input = bundle.querySelector('#fh-bundle-country');
    var searchBox = bundle.querySelector('.fh-bundle-search');
    if (!form || !input || !searchBox) return;
    form.setAttribute('action', '#gift-set');
    form.setAttribute('novalidate', 'novalidate');
    input.setAttribute('autocomplete', 'off');

    var results = document.createElement('div');
    results.className = 'fh-gift-search-results';
    results.hidden = true;
    searchBox.appendChild(results);

    var status = document.createElement('div');
    status.className = 'fh-gift-search-status';
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    searchBox.appendChild(status);

    function cardName(card) {
      var strong = card.querySelector('strong');
      return strong ? strong.textContent.trim() : '';
    }

    function cardCountry(card) {
      return (card.dataset.country || '').trim();
    }

    function cardImage(card) {
      var img = card.querySelector('img');
      return img ? (img.currentSrc || img.src || '') : '';
    }

    function cleanName(title) {
      return (title || '').replace(/\s*[:|-].*$/, '').replace(/\s+Handmade.*$/i, '').trim();
    }

    function productCountry(title) {
      var cleaned = cleanName(title);
      return cleaned.replace(/\s+Flag\s+Bracelet.*$/i, '').replace(/\s+Bracelet.*$/i, '').trim();
    }

    function productImage(product) {
      if (!product) return '';
      if (typeof product.image === 'string') return product.image;
      if (product.image && product.image.url) return product.image.url;
      if (product.featured_image && product.featured_image.url) return product.featured_image.url;
      if (typeof product.featured_image === 'string') return product.featured_image;
      return '';
    }

    function allCards() {
      return Array.prototype.slice.call(bundle.querySelectorAll('.fh-bundle-card'));
    }

    function localMatches(query) {
      var q = query.trim().toLowerCase();
      if (!q) return [];
      var exact = allCards().filter(function (card) {
        return cardCountry(card).toLowerCase() === q;
      });
      var partial = allCards().filter(function (card) {
        var country = cardCountry(card).toLowerCase();
        var name = cardName(card).toLowerCase();
        return country !== q && (country.indexOf(q) !== -1 || name.indexOf(q) !== -1);
      });
      return exact.concat(partial).slice(0, 6);
    }

    function localItem(card) {
      return {
        type: 'card',
        key: 'card:' + cardName(card).toLowerCase(),
        country: cardCountry(card).split(' ')[0] || cardCountry(card),
        name: cardName(card),
        image: cardImage(card),
        card: card
      };
    }

    function productItem(product) {
      var url = product.url || (product.handle ? '/products/' + product.handle : '#');
      var name = cleanName(product.title || product.name || '');
      return {
        type: 'product',
        key: 'product:' + url,
        country: productCountry(name),
        name: name,
        image: productImage(product),
        url: url
      };
    }

    function itemHandle(item) {
      var match = item && item.url ? item.url.match(/\/products\/([^?#]+)/) : null;
      return match ? match[1] : '';
    }

    function mergeItems(localItems, productItems) {
      var seen = {};
      return localItems.concat(productItems).filter(function (item) {
        var key = (item.name || '').toLowerCase();
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 8);
    }

    function showStatus(message) {
      status.hidden = false;
      status.textContent = message;
    }

    function hideStatus() {
      status.hidden = true;
      status.textContent = '';
    }

    function hideNativeSuggestions() {
      Array.prototype.slice.call(searchBox.querySelectorAll('div,ul,ol')).forEach(function (node) {
        if (node === results || node === status || form.contains(node) || results.contains(node) || status.contains(node)) return;
        if (/Shop .+ bracelet|Shop .+ Bracelet|→/.test(node.textContent || '')) {
          node.hidden = true;
          node.style.setProperty('display', 'none', 'important');
          node.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    }

    var selectedProducts = [];
    var searchToken = 0;
    var productCache = {};
    var suggestedCards = [];

    function buildSuggestedCards() {
      var preferred = ['Brazil', 'Aruba', 'Zimbabwe', 'Colombia', 'Bahamas', 'Canada', 'Norway', 'Scotland'];
      var cards = allCards();
      suggestedCards = preferred.map(function (country) {
        return cards.find(function (card) {
          return cardCountry(card).toLowerCase().indexOf(country.toLowerCase()) !== -1;
        });
      }).filter(Boolean);
      if (suggestedCards.length < 8) {
        cards.forEach(function (card) {
          if (suggestedCards.indexOf(card) === -1 && suggestedCards.length < 8) suggestedCards.push(card);
        });
      }
    }

    function showSuggestedCards() {
      if (!suggestedCards.length) buildSuggestedCards();
      var cards = allCards();
      cards.forEach(function (card) {
        card.style.display = suggestedCards.indexOf(card) !== -1 ? '' : 'none';
      });
    }

    function isSelected(item) {
      if (item.type === 'card') return item.card.classList.contains('is-selected');
      return selectedProducts.some(function (selected) {
        return selected.key === item.key || selected.name === item.name;
      });
    }

    function selectedCardNames() {
      return allCards().filter(function (card) {
        return card.classList.contains('is-selected');
      }).map(cardName);
    }

    function renderGiftSummary() {
      var names = selectedCardNames().concat(selectedProducts.map(function (item) {
        return item.name;
      })).filter(function (name, index, array) {
        return name && array.indexOf(name) === index;
      });
      var count = bundle.querySelector('[data-gift-count]');
      var list = bundle.querySelector('[data-gift-list]');
      var total = bundle.querySelector('[data-gift-total]');
      if (count) count.textContent = names.length + ' selected';
      if (list) list.innerHTML = names.length ? names.map(function (name) {
        return '<div>' + name.replace(/[<>&]/g, function (char) {
          return {'<':'&lt;','>':'&gt;','&':'&amp;'}[char];
        }) + '</div>';
      }).join('') : 'Choose bracelets to start your set.';
      if (total) total.textContent = names.length ? '$' + (names.length * 19.99 * 0.90).toFixed(2) : '—';
    }

    function selectedGiftItems() {
      var cardItems = allCards().filter(function (card) {
        return card.classList.contains('is-selected');
      }).map(function (card) {
        return {
          type: 'card',
          name: cardName(card),
          country: cardCountry(card)
        };
      });
      return cardItems.concat(selectedProducts).filter(function (item, index, array) {
        return item.name && array.findIndex(function (match) {
          return match.name === item.name;
        }) === index;
      });
    }

    function addItem(item) {
      if (!item) return;
      if (item.type === 'card') {
        item.card.style.display = '';
        var button = item.card.querySelector('button');
        if (!item.card.classList.contains('is-selected') && button) button.click();
      } else if (!isSelected(item)) {
        selectedProducts.push(item);
      }
      renderGiftSummary();
      showStatus(item.name + ' added to your gift set.');
      input.value = '';
      renderResults('', []);
      showSuggestedCards();
    }

    function renderResults(query, items) {
      hideNativeSuggestions();
      results.innerHTML = '';

      if (!query.trim()) {
        results.hidden = true;
        hideStatus();
        return;
      }

      if (!items.length) {
        results.hidden = true;
        showStatus('No matching bracelet found. Try another country name.');
        return;
      }

      hideStatus();
      results.hidden = false;
      items.forEach(function (item) {
        var result = document.createElement('div');
        result.className = 'fh-gift-search-result';
        if (isSelected(item)) result.className += ' is-selected';

        var img = document.createElement('img');
        img.alt = item.name;
        if (item.image) img.src = item.image;

        var text = document.createElement('span');
        var country = document.createElement('span');
        country.className = 'fh-gift-search-country';
        country.textContent = item.country || 'Bracelet';
        var name = document.createElement('span');
        name.className = 'fh-gift-search-name';
        name.textContent = item.name;
        text.appendChild(country);
        text.appendChild(name);

        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'fh-gift-search-add';
        add.textContent = isSelected(item) ? 'Added' : '+ Add';
        add.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          addItem(item);
        });

        result.appendChild(img);
        result.appendChild(text);
        result.appendChild(add);
        results.appendChild(result);
      });
    }

    function searchProducts(query, callback) {
      var q = query.trim();
      if (q.length < 2) {
        callback([]);
        return;
      }
      var cacheKey = q.toLowerCase();
      if (productCache[cacheKey]) {
        callback(productCache[cacheKey]);
        return;
      }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q + ' flag bracelet') + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          var items = products.map(productItem).filter(function (item) {
            return /bracelet/i.test(item.name);
          });
          productCache[cacheKey] = items;
          callback(items);
        })
        .catch(function () {
          callback([]);
        });
    }

    function findProductForItem(item) {
      var handle = itemHandle(item);
      if (handle) return Promise.resolve(handle);
      return fetch('/search/suggest.json?q=' + encodeURIComponent(item.name) + '&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last')
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          var match = products[0] ? productItem(products[0]) : null;
          return itemHandle(match);
        });
    }

    function variantIdForItem(item) {
      return findProductForItem(item).then(function (handle) {
        if (!handle) return null;
        return fetch('/products/' + handle + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (product) {
            return product && product.variants && product.variants[0] ? product.variants[0].id : null;
          });
      });
    }

    function setupGiftCheckout() {
      var checkout = bundle.querySelector('[data-gift-checkout]');
      if (!checkout || checkout.dataset.fhCartCheckout === 'true') return;
      checkout.dataset.fhCartCheckout = 'true';
      checkout.setAttribute('href', '/cart?discount=FIRSTORDER');
      checkout.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        var items = selectedGiftItems();
        if (!items.length) {
          showStatus('Choose at least one bracelet before checkout.');
          return false;
        }

        var originalText = checkout.textContent;
        checkout.textContent = 'Adding gift set...';
        checkout.style.pointerEvents = 'none';

        Promise.all(items.map(variantIdForItem)).then(function (ids) {
          var cartItems = ids.filter(Boolean).map(function (id) {
            return { id: id, quantity: 1 };
          });
          if (!cartItems.length) throw new Error('No variants found');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          window.location.href = '/cart?discount=FIRSTORDER';
        }).catch(function () {
          checkout.textContent = originalText;
          checkout.style.pointerEvents = '';
          showStatus('Could not add the full set automatically. Please try again.');
        });

        return false;
      }, true);
    }

    function searchAllCountries(query) {
      var token = ++searchToken;
      var localItems = localMatches(query).map(localItem);
      renderResults(query, localItems);
      searchProducts(query, function (productItems) {
        if (token !== searchToken) return;
        renderResults(query, mergeItems(localItems, productItems));
      });
    }

    function showPicker(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
      searchAllCountries(input.value);
      return false;
    }

    form.addEventListener('submit', showPicker, true);
    form.addEventListener('submit', showPicker, false);
    input.addEventListener('input', function () {
      searchAllCountries(input.value);
      window.setTimeout(hideNativeSuggestions, 0);
      window.setTimeout(hideNativeSuggestions, 80);
      window.setTimeout(showSuggestedCards, 0);
      window.setTimeout(showSuggestedCards, 80);
    });
    input.addEventListener('focus', hideNativeSuggestions);
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      showPicker(event);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target === form || form.contains(event.target)) showPicker(event);
    }, true);
    allCards().forEach(function (card) {
      var button = card.querySelector('button');
      if (!button) return;
      button.addEventListener('click', function () {
        window.setTimeout(renderGiftSummary, 0);
        window.setTimeout(showSuggestedCards, 0);
      }, true);
    });
    setupGiftCheckout();

    if (window.MutationObserver) {
      new MutationObserver(hideNativeSuggestions).observe(searchBox, {
        childList: true,
        subtree: true
      });
    }
    buildSuggestedCards();
    showSuggestedCards();
    hideNativeSuggestions();
  }

  function setupLeadPopup() {
    var isHome = location.pathname === '/' || document.body.classList.contains('template-index') || document.querySelector('[data-fahari-home]');
    if (!isHome || document.getElementById('fh-lead-popup')) return;
    try {
      if (sessionStorage.getItem('fhLeadPopupV2Dismissed') === 'true') return;
    } catch (error) {}

    var popup = document.createElement('div');
    popup.id = 'fh-lead-popup';
    popup.className = 'fh-lead-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'fh-lead-popup-title');
    popup.innerHTML = [
      '<div class="fh-lead-popup__card">',
      '<button class="fh-lead-popup__close" type="button" aria-label="Close popup">&times;</button>',
      '<div class="fh-lead-popup__media"><img src="' + (window.fhPopupUsaImage || '') + '" alt="USA flag bracelet"></div>',
      '<div class="fh-lead-popup__content">',
      '<p class="fh-lead-popup__kicker">Welcome to Fahari</p>',
      '<h2 id="fh-lead-popup-title">Get 10% off your first bracelet.</h2>',
      '<p>Choose your country, build a gift set, or start with one bracelet that carries meaning.</p>',
      '<form method="post" action="/contact#contact_form" accept-charset="UTF-8">',
      '<input type="hidden" name="form_type" value="customer">',
      '<input type="hidden" name="contact[tags]" value="newsletter, popup">',
      '<input type="hidden" name="return_to" value="/discount/FIRSTORDER?redirect=/collections/all">',
      '<input type="email" name="contact[email]" placeholder="Enter your email" required>',
      '<button type="submit">Get my discount</button>',
      '</form>',
      '<div class="fh-lead-popup__links"><a href="/collections/all">Shop best sellers</a><a href="/#gift-set">Build a gift set</a></div>',
      '</div>',
      '</div>'
    ].join('');

    function dismiss() {
      popup.classList.remove('is-open');
      try {
        sessionStorage.setItem('fhLeadPopupV2Dismissed', 'true');
      } catch (error) {}
      window.setTimeout(function () {
        if (popup.parentNode) popup.parentNode.removeChild(popup);
      }, 260);
    }

    document.body.appendChild(popup);
    popup.querySelector('.fh-lead-popup__close').addEventListener('click', dismiss);
    popup.addEventListener('click', function (event) {
      if (event.target === popup) dismiss();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
    });
    popup.querySelector('form').addEventListener('submit', function () {
      try {
        sessionStorage.setItem('fhLeadPopupV2Dismissed', 'true');
      } catch (error) {}
    });
    window.setTimeout(function () {
      popup.classList.add('is-open');
    }, 2200);
  }

  function init() {
    addStyle();
    removeProcessSection();
    improveCopy();
    giftSearchAddsToSet();
    setupLeadPopup();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
